<template>
  <div v-if="store.form.currentStep === 'stepFive' || store.debug">
<!--    <Steps class="mt-4 mt-md-0"/>-->

    <div id="thankYou" class="p-5 text-center">
      <div class="circle border-secondary ml-auto mr-auto d-flex justify-content-center align-items-center mb-4">
        <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.9502 7.90015L8.2002 13.1501L18.7002 2.65015" stroke="#EF4956" stroke-width="3" stroke-linecap="square"/>
        </svg>
      </div>

<!--      Aby se to zavolalo až když se zobrazí Thank you page-->
      {{ this.store.vueClarityEvent('thank-you')}}
      {{ this.store.seatClarityEvent('thank-you')}}

      <p class="header text-center">{{ t('thankYou.dekujeme') }}
        <span v-if="store.order.type === 'order'">{{ t('thankYou.objednavku') }}</span>
        <span v-else>{{ t('thankYou.poptavku') }}</span>
        <span v-if="lang === 'cs'">&nbsp{{ t('thankYou.sidla') }}</span>!
      </p>

<!--      pro českou poptávku se posílají emaily - má jiný text-->
      <p v-if="store.order.type === 'demand'">
        <span v-html="t('thankYou.demandEmail.beforeEmail')"></span>
        <b>{{ store.order.contactInfo.email }}</b>
        <span v-html="t('thankYou.demandEmail.afterEmail')"></span>
      </p>
<!--      Pro thank you u objednávky z cz - zde se už bude posílat email-->
      <p v-else-if="store.order.type === 'order'">
        <span v-html="t('thankYou.orderBeforeEmail')"></span>
        <strong>&nbsp{{ store.order.contactInfo.email }}<span v-if="lang==='cs'">&nbsp</span></strong>
        <span v-html="t('thankYou.orderAfterEmail')"></span>
      </p>
<!--      <p v-else>-->
<!--        <span>{{ t('thankYou.vasi') }}&nbsp</span>-->
<!--        <span v-if="store.order.type === 'order'">{{ t('thankYou.objednavku') }}</span>-->
<!--        <span v-else>{{ t('thankYou.poptavku') }}</span> {{ t('thankYou.beforeEmail') }}-->
<!--        <b>{{ store.order.contactInfo.email }}</b>{{ t('thankYou.afterEmail') }}-->
<!--      </p>-->


      <p>
        {{ t('thankYou.kontakt.before') }} <b> {{ t('thankYou.kontakt.strong') }}
        <a :href="t('thankYou.kontakt.url')">{{ t('thankYou.kontakt.link') }}</a></b>.
      </p>

      <p>{{ t('thankYou.blog') }}</p>
      <div class="text-center">
        <a class="btn btn-secondary" :href="blogUrl" target="_blank" rel="noopener">{{ t('thankYou.blogButton') }}</a>

      </div>
    </div>

  </div>

</template>

<script>
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import {store} from "../store.js";
import Steps from "../others/StepsComponent/Steps.vue";

export default {
  name: "ThankYou",
  components: {Steps},
  props: ['currentStep'],

  setup() {
    const {t, locale} = useI18n({useScope: 'global'})
    const lang = locale;
    const select = ref(0)
    console.log('lang',lang);
    return {t, select, lang}
  },
  data() {
    return {
      errors: [],
      store,

    }
  },
  methods: {},
  computed: {
    blogUrl() {
      const microsites = ['sidlofirmy-brno.cz', 'sidlo-praha3.cz', 'sidlo-praha10.cz', 'sidlonapraze1.cz', 'sidlofirmy-praha.cz'];
      const host = document.referrer ? new URL(document.referrer).host : window.location.host;
      if (microsites.some(site => host.includes(site))) {
        return 'https://www.jake-james.cz/blog';
      }
      if (this.lang === 'en') return 'https://www.jake-james.com/blog';
      if (this.lang === 'sk') return 'https://www.jake-james.sk/blog';
      return 'https://www.jakejames.cz/blog';
    }
  },
  created() {


  },

}
</script>

<style lang="scss" scoped>
#thankYou {
  p {
    font-size: 14px;
    font-weight: 600
  }

  .header {
    font-size: 1.4rem;
    color: #ef4956;
    font-weight: bold;
  }

  .circle {
    width: 43px;
    height: 43px;
    border-radius: 50%;
    border-width: 3px;
    border-style: solid;
  }
}

</style>